import { useEffect, useState } from "react";
import { Signle_Call } from "../Api/Api";
import { ExamTimeTypes, ExamTime } from "../../Functions";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Button } from "react-bootstrap";
import { Skeleton } from "@material-ui/lab";
const ExamList = () => {
  const [loader, setLoader] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);
  const [list, setList] = useState([]);
  const [examCount, setExamCount] = useState(0);

  useEffect(() => {
    handle_getList();
  }, []);

  const handle_getList = async () => {
    const apiCall = () => {

      const apiCall = async (tools) => {
        const ApiCall = await Signle_Call(tools);
        return ApiCall;
      };

      return new Promise((result) => {
        result(
          apiCall({
            method: "get",
            data: false,
            path: `exams`,

          })
        );
      });
    };
    const getExamList = await apiCall();
    setPageLoading(false);
    setList(getExamList.response.data.exams);
    setExamCount(getExamList.response.data.active_exams_count);
  };

  const history = useHistory();
  const handle_getExamInfo = async (id, exam,seeAnswers) => {
    setLoader(id);
    const apiCall = () => {

      const apiCall = async (tools) => {
        const ApiCall = await Signle_Call(tools);
        return ApiCall;
      };
      return new Promise((result) => {
        result(
          apiCall({
            method: "get",
            data: false,
            path: `exam/${id}`,

          })
        );
      });
    };
    const getExam_result = await apiCall();
    localStorage.setItem("lastExam", JSON.stringify(exam));
    setLoader(0);
    if (
      getExam_result?.type &&
      getExam_result?.response?.data?.questions?.length
    ) {
      getExam_result.response.data.exam_id = id;
      localStorage.setItem(
        "examTimeLeft",
        ExamTime(ExamTimeTypes.encrypt, getExam_result.response.data.exam_time)
      );
      
      history.push(seeAnswers ? `/examList/ended-exam/${exam.id}` : "/exam", { ...getExam_result.response.data });
    }
  };

  return (
    <div className="examList contain">
      {list.length ? (
        <>
          <div className="examCount">
            <div className="count">
              {pageLoading ? (
                <Skeleton
                  width={30}
                  height={30}
                  className="countLoading"
                  animation="wave"
                />
              ) : (
                <>
                  <span>{examCount}</span>
                  <span>ازمون</span>
                </>
              )}
            </div>
          </div>
          <div className="list">
            {pageLoading
              ? [...Array(6).keys()].map(() => (
                  <div className="skeletonItem">
                    <Skeleton animation="wave" width={"100%"} height={100} />
                  </div>
                ))
              : list.map((exam, i) => (
                  <div className="examItem " key={i}>
                    <div className="picture">
                      <img src={exam.pic} alt="" />
                    </div>
                    <div className="details">
                      <div className="desc">
                        <span>{exam.title}</span>
                      </div>
                      <div className="time">
                        <span>
                          تاریخ شروع :
                          <b>
                            {exam.start_date === null && exam.stop_date === null
                              ? "آزاد"
                              : exam.start_date !== null &&
                                exam.stop_date === null
                              ? "آزاد"
                              : exam.start_date !== null
                              ? exam.start_date
                              : "آزاد"}
                          </b>
                        </span>
                        <span>
                          تاریخ پایان :
                          <b>
                            {exam.stop_date === null && exam.start_date === null
                              ? "آزاد"
                              : exam.stop_date !== null &&
                                exam.start_date === null
                              ? "آزاد"
                              : exam.stop_date !== null
                              ? exam.stop_date
                              : "آزاد"}
                          </b>
                        </span>
                      </div>
                    </div>
                    <div className="seeMore" >
                      {loader === exam.id ? (
                        <Button variant="contained">
                          <PulseLoader color="#fff" loading={true} size={12} />
                        </Button>
                      ) : (
                        <div style={{ display:"flex",flexDirection:"column",gap:".5rem",width:"100%" }}>
                          <button
                            disabled={
                              exam.is_exam_active === "inactive" ? true : false
                            }
                            onClick={() =>
                              loader === exam.id
                                ? null
                                : handle_getExamInfo(exam.id, exam,false)
                            }
                          >
                            شروع آزمون
                          </button>
                          {exam.exam_expired ?  <button
                            onClick={() =>
                              loader === exam.id
                                ? null
                                : handle_getExamInfo(exam.id, exam,true)
                            }
                          >
                            {/* `` */}
پاسخنامه
                          </button>: <></>} 
                        </div>
                      )}
                    </div>
                  </div>
                  // <div className="exam" key={i}>
                  //   <div className="exam-img">
                  //     <img
                  //       alt="img-exam"
                  //       src={exam.pic ? exam.pic : "/img/archive-book.png"}
                  //     />
                  //   </div>
                  //   <div className="exam-detail">
                  //     <span className="exam-title">{exam.title}</span>
                  //     <div className="info">
                  //       <span>
                  // {exam.is_exam_active === "active" &&
                  // exam.start_date === null &&
                  // exam.stop_date === null
                  //   ? null
                  //   : exam.is_exam_active === "inactive" &&
                  //     exam.start_date &&
                  //     exam.stop_date !== null
                  //   ? exam.start_date
                  //   : exam.is_exam_active === "inactive" &&
                  //     exam.start_date === null &&
                  //     exam.stop_date === null
                  //   ? "وقت این ازمون به اتمام رسیده است"
                  //   : exam.is_exam_active === "inactive" &&
                  //     exam.start_date === null &&
                  //     exam.stop_date !== null
                  //   ? exam.stop_date
                  //   : exam.is_exam_active === "inactive" &&
                  //     exam.start_date !== null &&
                  //     exam.stop_date === null
                  //   ? exam.start_date
                  //   : null}
                  //       </span>
                  //       {loader === exam.id ? (
                  //         <Button variant="contained">
                  //           <PulseLoader
                  //             color="#fff"
                  //             loading={true}
                  //             size={12}
                  //           />
                  //         </Button>
                  //       ) : (
                  //         <button
                  //           disabled={
                  //             exam.is_exam_active === "inactive" ? true : false
                  //           }
                  //           onClick={() =>
                  //             loader === exam.id
                  //               ? null
                  //               : handle_getExamInfo(exam.id, exam)
                  //           }
                  //         >
                  //           شروع آزمون
                  //         </button>
                  //       )}
                  //     </div>
                  //   </div>
                  // </div>
                ))}
          </div>
        </>
      ) : (
        <div className="exam-empty">
          <i className="icon-exclamation" />
          <span>در حال حاضر آزمون فعالی وجود ندارد</span>
        </div>
      )}
    </div>
  );
};

export default ExamList;
